import React, {useEffect, useMemo, useState} from 'react';

import {ReviewFeedback} from 'src/modules/ai/change-request-review/review-feedback/view/review-feedback';
import {getChangeRequestReview} from 'src/modules/ai/change-request-review/services';
import {TourAnchor} from 'src/modules/ai/tour/tour-anchor';
import {FieldReview} from 'src/openapi/models/FieldReview';
import {useAppSelector} from 'src/store';

import {Icons} from '@pb/kit-component-icon';

type Props = {
    changeRequestId: number | null,
    attributeName: string,
};

export const AttributeReviewFeedback = ({changeRequestId, attributeName}: Props) => {
    const [lastAttributeReview, setLastAttributeReview] = useState<FieldReview | null>(null);
    const changeRequestReview = useAppSelector(getChangeRequestReview)?.[changeRequestId || 0];
    const attributeReview = useMemo(() => {
        return changeRequestReview?.attributesReviews.find(attr => attr.fieldName === attributeName);
    }, [changeRequestReview, attributeName]);

    useEffect(() => {
        if (attributeReview) {
            setLastAttributeReview(attributeReview);
        }
    }, [attributeReview]);

    const hasAttributesReviews = changeRequestReview?.attributesReviews.length > 0;

    return (
        <>
            {hasAttributesReviews && lastAttributeReview ? (
                <ReviewFeedback field={lastAttributeReview}/>
            ) : (
                <>
                    {!attributeName && (
                        <TourAnchor
                            className="ai-feedback-tour"
                            icon={Icons.CHAT}
                        />
                    )}
                </>
            )}
        </>
    );
};
